function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef } from "react";
import PropTypes from "prop-types";
import MessageStyle from "./message.style";
import TypeIcon from "./type-icon/type-icon.component";
import MessageContent from "./message-content/message-content.component";
import tagComponent from "../../__internal__/utils/helpers/tags/tags";
import Icon from "../icon";
import IconButton from "../icon-button";
import { filterStyledSystemMarginProps } from "../../style/utils";
import useLocale from "../../hooks/__internal__/useLocale";
const Message = /*#__PURE__*/React.forwardRef(({
  open = true,
  transparent = false,
  title,
  variant = "info",
  children,
  onDismiss,
  id,
  className,
  closeButtonAriaLabel,
  showCloseIcon = true,
  ...props
}, ref) => {
  const messageRef = useRef(null);
  const refToPass = ref || messageRef;
  const marginProps = filterStyledSystemMarginProps(props);
  const l = useLocale();
  const renderCloseIcon = () => {
    if (!showCloseIcon || !onDismiss) return null;
    return /*#__PURE__*/React.createElement(IconButton, {
      "data-element": "close",
      "aria-label": closeButtonAriaLabel || l.message.closeButtonAriaLabel(),
      onClick: onDismiss
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    }));
  };
  return open ? /*#__PURE__*/React.createElement(MessageStyle, _extends({}, tagComponent("Message", props), {
    className: className,
    transparent: transparent,
    variant: variant,
    id: id,
    ref: refToPass
  }, marginProps, {
    tabIndex: -1
  }), /*#__PURE__*/React.createElement(TypeIcon, {
    variant: variant,
    transparent: transparent
  }), /*#__PURE__*/React.createElement(MessageContent, {
    showCloseIcon: showCloseIcon,
    title: title
  }, children), renderCloseIcon()) : null;
});
Message.propTypes = {
  "children": PropTypes.node,
  "className": PropTypes.string,
  "closeButtonAriaLabel": PropTypes.string,
  "id": PropTypes.string,
  "m": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "margin": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginBottom": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginLeft": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginRight": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginTop": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginX": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "marginY": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mb": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "ml": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mr": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mt": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "mx": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "my": PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.number, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string])), PropTypes.number, PropTypes.object, PropTypes.shape({
    "__@toStringTag": PropTypes.string.isRequired,
    "description": PropTypes.string,
    "toString": PropTypes.func.isRequired,
    "valueOf": PropTypes.func.isRequired
  }), PropTypes.string]),
  "onDismiss": PropTypes.func,
  "open": PropTypes.bool,
  "showCloseIcon": PropTypes.bool,
  "title": PropTypes.node,
  "transparent": PropTypes.bool,
  "variant": PropTypes.oneOf(["error", "info", "neutral", "success", "warning"])
};
export { Message };
Message.displayName = "Message";
export default Message;